import styled from "styled-components";

export const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 120px);
    grid-gap: 10px;
    width: 100%;
    min-height: 120px;
    flex-direction: row;
`;